import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core';
export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    backgroundColor: '#ffff',
    borderRadius: '10px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0 6px 8px rgba(0, 0, 0, 0.2)',
    },
  },
  contentImage: {
    justifyContent: 'center',
    alignItems: 'center',
    margin: 'auto 0 auto 40px',
    minWidth: '150px',
  },
  button: {
    marginRight: theme.spacing(2),
  },
  titleColumnCard: {
    fontWeight: 'bold',
  },
  filterCard: {
    padding: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1),
    border: '1px solid #ddd',
    borderRadius: theme.shape.borderRadius,
  },
  titleFilter: {
    fontWeight: 'bold',
  },
  cardGenerateOffer: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1),
    border: '1px solid #ddd',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: '#02CBF5',
  },
  textOffer: {
    fontWeight: 'bold',
    color: '#ffff',
  },
  fullWidthButton: {
    width: '100%',
    marginTop: 10,
    background: '#fff',
    color: '#009AEB',
    fontWeight: 'bold',
  },
  chipContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    margin: 'auto 0 auto 1px',
  },
  premiumChip: {
    minWidth: '140px',
    background: '#02CBF4',
    color: '#fff',
    fontWeight: 'bold',
  },
  estandarChip: {
    minWidth: '140px',
    background: '#2196f3',
    color: '#fff',
    fontWeight: 'bold',
  },
  basicChip: {
    minWidth: '140px',
    background: '#9e9e9e',
    color: '#fff',
    fontWeight: 'bold',
  },
  noClassChip: {
    minWidth: '140px',
    background: '#ffff',
    color: '#000',
    fontWeight: 'bold',
  },
}));
